<script lang="typescript">
    import { calenderTheme, symbolCodes } from "../config"
    import Symbol from "./Symbol.svelte"

    export let showfilter

    export let symbolFilter: {
        [key: number]: boolean
    }

    const onPageClick = () => {
        showfilter = false
    }

</script>

<svelte:body on:click="{onPageClick}" />

<div class="filter" class:active="{showfilter}">
    {#each symbolCodes as symbolCode}
        <div
            class="filter_icon"
            class:active="{symbolFilter[symbolCode]}"
            on:click="{() => {
                symbolFilter[symbolCode] = !symbolFilter[symbolCode]
            }}"
        >
            <Symbol symbolCode="{symbolCode}" showName breakName />
        </div>
    {/each}
</div>
